// 240px sidebar (desktop) / bottom tab bar (mobile, via CSS media query) — mirrors Diver's Horizon's
// DesktopLayout.jsx structurally; icon set matches the app mockups' tab bar.
const ICONS = {
  home: <path d="M3 11l9-7 9 7M5 10v9h14v-9" />,
  conditions: <path d="M3 18l6-11 4 6 3-4 5 9z" />,
  traffic: <path d="M12 2L2 20h20L12 2zM12 9v5M12 17h.01" />,
  lodging: <path d="M3 18v-5a2 2 0 012-2h14a2 2 0 012 2v5M3 18v2M21 18v2M3 13V7a2 2 0 012-2h3a2 2 0 012 2v2M11 11h10" />,
  carpool: <path d="M3 18l2-5h14l2 5M5 18h14M7.5 18a1.4 1.4 0 100-2.8 1.4 1.4 0 000 2.8zM16.5 18a1.4 1.4 0 100-2.8 1.4 1.4 0 000 2.8z" />,
};

function TabIcon({ id, active }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={active ? "var(--accent)" : "currentColor"}
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {ICONS[id] ?? ICONS.home}
    </svg>
  );
}

export function DesktopLayout({ tabs, activeTab, onSelectTab, children }) {
  return (
    <div className="desktop-layout">
      <aside className="sidebar glass">
        <div className="sidebar-brand">
          <img src="/icon-192.png" alt="" width="28" height="28" />
          Pow<span className="accent">Horizon</span>
        </div>
        <nav>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`sidebar-item${tab.id === activeTab ? " active" : ""}`}
              onClick={() => onSelectTab(tab.id)}
            >
              <TabIcon id={tab.id} active={tab.id === activeTab} />
              {tab.label}
            </button>
          ))}
        </nav>
      </aside>
      <main className="desktop-main">{children}</main>
    </div>
  );
}
